import { Page } from "./pages";

interface SitemapPage {
  page: Page;
  pages: SitemapPage[];
}

function page(page: Page, pages?: SitemapPage[]): SitemapPage {
  return {
    page,
    pages,
  };
}

export const Sitemap = {
  home: page(Page.workspaceHome),
  discovery: page(Page.discovery),
  insightPages: page(Page.insightPagesHome, [
    page(Page.insightPagesPage),
    page(Page.insightPagesEditor),
    page(Page.insightPagesWizardEditor),
  ]),
  listening: page(Page.listeningQueriesOverview, [
    page(Page.listeningQueriesOverview),
    page(Page.listeningAnalytics),
    page(Page.listeningInfluencers),
    page(Page.listeningLiveMonitoring),
    page(Page.listeningClusters),
    page(Page.listeningYoutubeAnalytics, [
      page(Page.listeningYoutubeAnalytics),
      page(Page.listeningYoutubeInfluencers),
    ]),
    page(Page.listeningContentLandscape),
    page(Page.imageClustering),
  ]),
  social: page(Page.socialPerformanceOwnedOverview, [
    page(Page.socialPerformanceOwnedOverview, [
      page(Page.socialPerformanceOwnedOverview),
      page(Page.socialPerformanceOwnedDetails),
      page(Page.socialPerformanceOwnedPosts),
      page(Page.socialPerformanceOwnedFollowersMap),
    ]),
    page(Page.socialPerformanceBenchmarkOverview, [
      page(Page.socialPerformanceBenchmarkOverview),
      page(Page.socialPerformanceBenchmarkDetails),
      page(Page.socialPerformanceBenchmarkDuel),
    ]),
  ]),
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type Sitemap = typeof Sitemap;
